import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

// CSS
import "./VerificationPage.css";

// Components
import Button from "../../Components/Other Components/button";
import Title from "../../Components/Other Components/Title";

// Functions and hooks
import { VerifyUserRequestByToken } from "../../BackendAccess/UserHooks";
import { useNotification } from "../../Contexts/NotificationContext";

export default function VerifiedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(false);
  let verifying = false;

  const token = searchParams.get("token");
  const { showNotification } = useNotification();

  useEffect(() => {
    if (token && !verifying) {
      verifying = true;
      verifyEmail();
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const [data, err] = await VerifyUserRequestByToken(token);
      if (err) throw err;
      showNotification(t("verified.success"), "success");
    } catch {
      showNotification(t("verified.error"), "error");
      setError(true);
    } finally {
      verifying = false;
    }
  };

  const onLoginClick = () => navigate("/login");

  return (
    <PageWrapper>
      <div className="page-content">
        <div className="container-bordered verification-container mt-3">
          <Title>
            {error ? t("verified.title.error") : t("verified.title.success")}
          </Title>
          <span className="verification-text font-bold">
            {error
              ? t("verified.message.error")
              : t("verified.message.success")}
          </span>
          <span className="verification-text">
            {error
              ? t("verified.message.nextOnError")
              : t("verified.message.nextOnSuccess")}
          </span>
          <div className="btn-container mt-3 w-100">
            <Button onClick={onLoginClick}>{t("verified.button.login")}</Button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
